module.exports = __webpack_public_path__ + "img/x-icon.c9c3b53e.svg";